export var enUS = 'en-US';
export var esMX = 'es-MX';
export var defaultLocale = enUS;
export var STATIC_NAMESPACE = 'translation';
export var OPTION_NAMESPACE = 'questionOptions';
export var HELPER_NAMESPACE = 'questionHelpers';
export var SETTINGS_NAMESPACE = 'partnerSettings';
export var WIDGET_NAMESPACE = 'widget';
